<template>
	<div>
		<indexHeader ref="indexHeader"></indexHeader>
		<div id="app">
		  <!--<div class="print" v-if="!isPrint" @click="startPrint()">下载</div>-->
		  <div v-if="data" class="pxzm_con" id="pxzm_con">
		    <h1>信用培训证明</h1>
		    <p>{{data.qyFdxm}} 系 {{data.qyMc}} 法定代表人，授权{{data.pxrXm}}参加我司举办的信用培训课程，并于{{data.xxglTgrqN}}年{{data.xxglTgrqY}}月{{data.xxglTgrqR}}日通过培训考试。</p>
		    <p>课程内容如下：</p>
		    <p v-for="item in data.kcMc" style="margin-bottom: 20px">
		      《{{item}}》
		    </p>
		    <p style="margin-bottom: 40px">已完成3学时课程，课后测评得分{{data.xxglKstgdf}}分（满分100分），培训成绩合格。</p>
		    <p>特此证明。</p>
		    <div class="sm">
		      <p>信用服务机构名称：{{data.xyjgmc}}</p>
		      <p>{{data.pxzmrqN}}年{{data.pxzmrqY}}月{{data.pxzmrqR}}日</p>
		    </div>
		  </div>
		</div>
		<indexFooter></indexFooter>
	</div>
  
</template>
<script type="text/ecmascript-6">
  import 'babel-polyfill'//IE9，模拟ES6环境
  import {cookie} from '@/common/js/cookies.js'
  import jsPDF from 'jspdf'
import indexHeader from "@/components/index/index_header";
import indexFooter from "@/components/index/index_footer";
  export default {
    name: 'app',
    data() {
      return {
        qyId: null,
        pxrId : null,
        isPrint : false,
        data : null,
      }
    },
    computed: {},
    created: function () {
      this.qyId = this.$route.query.qyId;
      this.pxrId = this.$route.query.pxrId;
    },
    mounted() {
      let _self = this;

      _self.pxzm();
    },
    methods: {
      setQz (base64,callback){//加盖电子签章
        let _self = this;
        let ajax = _self.$http.create();
        const loading = this.$loading({
          lock: true,
          text: "加盖签章中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        ajax({
          method: "post",
          url: SOWINURL + "report/setQz",
          data: {
            qz : base64,
            lx : '6',
            qyId : _self.qyId
          },
					headers:{
						'token': cookie.get("xyxf_token_qt")
					}
        })
          .then(function(json) {
            // console.log(json.data);
            if (json.data.result == 1) {
              window.location.href = json.data.data;
              callback && callback();
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error"
              });
            }
            loading.close();
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      printPDF(){
        let _self = this;
        var target = document.getElementById('pxzm_con');
        target.style.background = "#FFFFFF";
        // 794 1123
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        html2canvas(target, {
          onrendered:function(canvas) {
            var contentWidth = canvas.width;
            var contentHeight = canvas.height;

            //一页pdf显示html页面生成的canvas高度;
            var pageHeight = contentWidth / 592.28 * 841.89;
            //未生成pdf的html页面高度
            var leftHeight = contentHeight;
            //页面偏移
            var position = 0;
            //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
            var imgWidth = 595.28;
            var imgHeight = 592.28/contentWidth * contentHeight;

            var pageData = canvas.toDataURL('image/jpeg', 1.0);

            var pdf = new jsPDF('', 'pt', 'a4');

            //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
            //当内容未超过pdf一页显示的范围，无需分页
            if (leftHeight < pageHeight) {
              pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight );
            } else {
              while(leftHeight > 0) {
                pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                leftHeight -= pageHeight;
                position -= 841.89;
                //避免添加空白页
                if(leftHeight > 0) {
                  pdf.addPage();
                }
              }
            }
            let datauri = pdf.output('dataurlstring');
            let base64 = datauri.substring(28);
            console.log(pdf);
            _self.setQz(base64,function(){
              _self.isPrint = false;
              loading.close();
              target.style.background = "none";
              // pdf.save("content.pdf");
            });


          }
        })
      },
      pxzm (){
        let _self = this;
        let ajax = _self.$http.create();
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ajax({
          method: 'post',
          url: SOWINURL + 'report/pxzm',
          data : {
            qyId : _self.qyId,
            pxrId : _self.pxrId,
          },
		  headers:{
		  	'token': cookie.get("xyxf_token_qt")
		  }
        }).then(function (json) {
          // console.log(json.data);
          if (json.data.result == 1) {
            _self.data = json.data.data;
            _self.startPrint();
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: 'error'
            });
            if(json.data.result == 2){
              setTimeout(()=>{
                //登录失效删除token
                cookie.delete('xyxf_token_qt');
                window.location.href = SOWINURL + 'index/login';
              },2000);
            }
          }
          loading.close();

        }).catch(function (error) {
          console.log(error);
        });
      },
      startPrint(){
        let _self = this;
        this.isPrint = true;
        setTimeout(function(){
          _self.printPDF();
        },500)
      }
    },
    components: {
			indexHeader,
			indexFooter
		},
    watch: {}
  }
</script>

<style scoped lang="less" type="text/less">

  * {
    margin: 0;
    padding: 0;
  }

  html, body {
    width: 100%;
    height: 100%;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    background: url("/static/images/muban_bg.png") repeat;
    li {
      list-style: none;
    }

    img {
      border: 0 none;
      vertical-align: top;
    }

    a {
      text-decoration: none;
    }
  }

  div {
    position: relative;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  h3{
    margin-top: 28px;
    height: 54px;
    font-size: 30px;
    text-align: center;
  }
  p{
    text-indent: -1em;
    line-height: 54px;
    font-size: 14px;
    padding-left: 1em;
  }

  .print{
    width: 120px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    border-radius: 20px;
    text-align: center;
    position: fixed;
    right: 5%;
    top: 10%;
    cursor: pointer;
    z-index: 10;
    background: -webkit-linear-gradient(left, #0076ff, #00c9ff); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #0076ff, #00c9ff); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #0076ff, #00c9ff); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
  }
  @page{
    margin-bottom: 0mm;
    margin-top: 0mm;
    margin-left: 0mm;
    margin-right: 0mm;
  }
  .pxzm_con{
    width: 1200px;
    min-height: 720px;
    padding: 40px 0;
    margin: 0 auto;
    position: relative;
    .sm{
      margin-top: 40px;
      position: absolute;
      right: 35px;
      bottom: 20px;
      width: 600px;
      height: 110px;
      text-align: center;
      padding-top: 40px;
      /*background: url("/static/images/gz.png") no-repeat center;*/
      p{
        width: 100%;
      }
    }
    h1{
      height: 86px;
      line-height: 86px;
      font-size: 30px;
      text-align: center;
      color: #070f36;
      margin-bottom: 17px;
    }
    p{
      width: 1000px;
      margin: 0 auto;
      line-height: 38px;
      font-size: 20px;
      color: #070f36;
      text-indent: 2em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/pxzm/pxzm.vue